import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const {
  colors: { ui, brand },
} = constants;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { sm, md },
}: { BreakpointNames: { xs: string; sm: string; md: string } } =
  constants.breakpoints;

export const recursiveTagCheckboxCss = {
  padding: 0,
};

export const recursiveTagLabelCss = (level: number) => ({
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.heading3,
  color: level === 2 ? ui.neutral[700] : ui.neutral[600],
  fontWeight: level === 2 ? 700 : 400,

  "& label::focus-within": {
    outlineOffset: "0px",
  },

  [mq.between(sm, md)]: {
    width: "323px",
  },
});

export const innerTagStyle: CSSObject = {
  width: "396px",
  paddingRight: "8px",
};

export const fieldsetCss = (level: number) => ({
  border: "none",
  padding: 0,
  marginBottom: "8px",
  paddingLeft: level > 1 ? "8px" : 0,
});

export const collapseTitleContainer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  backgroundColor: brand.neutral[25],
  borderRadius: "8px",
  marginBottom: "16px",
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.heading3,
};

export const collapseLabel = {
  fontWeight: 700,
  marginLeft: "16px",
  color: ui.black[700],
};

export const subTopicsCounterLabel = {
  fontWeight: 400,
  marginLeft: "-8px",
};

export const collapseButton = {
  marginRight: "24px",
};

export const collapseContainer = {
  width: "100%",
};

export const collapseStyle = {
  Button: {
    root: collapseContainer,
  },
  root: {
    "& label": {
      paddingInline: 0,
    },
  },
  expanderContent: {
    overflow: "hidden",
    columnCount: 2,
    [mq.upTo(sm)]: {
      columnCount: "unset",
    },
  },
};
